import * as color from './color';

export const $Color = color;

export { from, toHexString, toRGB, toRGBA, getGradientColor } from './color';
export type { Color, ColorInput } from './color';
